import type { Plugin } from "vue";

export default {
  install(app) {
    app.config.globalProperties.pluralize = pluralize;
    app.config.globalProperties.formatLevel = formatLevel;
    app.config.globalProperties.formatWorkshop = formatWorkshop;
  },
} as Plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    pluralize: typeof pluralize;
    formatLevel: typeof formatLevel;
    formatWorkshop: typeof formatWorkshop;
  }
}
